// Check if the value is empty.
export const isItEmpty = (value) => {
    if (typeof value === "object") {
        if (value === null || Object.keys(value).length === 0) {
            return true
        } else {
            return false
        }
    } else {
        if (value === null || value === undefined || value === "") {
            return true
        }
    }
    return false
}

export const shuffleArray = <T>(array: T[]) => {
    for (let i = array.length - 1; i >= 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[array[i], array[j]] = [array[j], array[i]]
    }

    return array
}
